import { GAMEPLAY_CONFIG } from '../../app/config';

export class ScoreService {
  private currentScore = 0;

  public constructor(private bestScore = 0) {}

  public get score(): number {
    return this.currentScore;
  }

  public get highScore(): number {
    return this.bestScore;
  }

  public asteroidPassed(alreadyScored: boolean, destroyed: boolean): boolean {
    if (alreadyScored || destroyed) return false;
    this.add(GAMEPLAY_CONFIG.score.pass);
    return true;
  }

  public asteroidDestroyed(): void {
    this.add(GAMEPLAY_CONFIG.score.destroy);
  }

  public bonus(points: number): void {
    this.add(Math.max(0, Math.floor(points)));
  }

  public reset(): void {
    this.currentScore = 0;
  }

  private add(points: number): void {
    this.currentScore += points;
    this.bestScore = Math.max(this.bestScore, this.currentScore);
  }
}
